import { Box, Circle, AHText, useLayoutContext, AHIcon } from "arkh";
import React from "react";

export function TeamSectionHeaderCTAButton(props: {
  ctaTitle: React.ReactNode;
  icon?: React.ReactNode;
}) {
  const layout = useLayoutContext();
  return (
    <Box
      style={{
        height: layout.circle.medium,
        borderRadius: layout.circle.medium / 2,
        borderWidth: 1,
        flexDirection: "row",
        alignItems: "center",
      }}
      borderColor="border-primary"
    >
      <AHText type="info-small" color="text-secondary" spaceLeft="medium">
        {props.ctaTitle}
      </AHText>
      <Circle
        size="medium"
        style={{
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        {props.icon ?? <AHIcon type="chevron-right" color="text-secondary" />}
      </Circle>
    </Box>
  );
}
